// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckoutCartItemsCarousel_container__ga1yn","carousel":"CheckoutCartItemsCarousel_carousel__8ZrnR"};